<div class="seperator"></div>
<div class="title" mat-dialog-title>
    Enable IAS
    <img class="logo" src="https://rubii-images.s3-ap-southeast-2.amazonaws.com/dsp/ias.svg" alt="IAS" />
</div>
<div class="gmail-body">
    <div style="text-align: left;">
        <div>Please schedule a daily IAS report and send to below email: </div>
        <div class="report-email-container">
            <div style="font-weight: 600;">Recipient email address</div>
            <div class="ias-email">
                {{ iasEmail }}  
                <button mat-icon-button (click)="copyMessageToClipboard(iasEmail)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>
        <div class="ias-template-link"><a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/ias.xlsx"
                target="_blank" data-cy="ias-template-link"> Download a sample report </a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>
